<template>
  <!--<v-app :style="hScroller">-->
  <v-app>
    <v-container fluid fill-height class="py-0 px-1">
      <v-layout justify-center align-center>
        <v-flex shrink>
          <slot/>

          <!-- Canvas zoom controls -->
          <v-btn
            color="grey darken-1"
            dark
            fab
            fixed
            bottom
            left
            @click="changeZoom('out')"
          >
            <!--@mousedown="continuousZoom('out')"-->
            <!--@touchstart="continuousZoom('out')"-->
            <v-icon>zoom_out</v-icon>
          </v-btn>
          <v-btn
            color="white"
            fixed
            disabled
            bottom
            left
            style="margin-left: 55px; margin-bottom: 10px;"
          >
            {{ parseInt(canvasZoom) }} %
          </v-btn>
          <v-btn
            color="grey darken-1"
            dark
            fab
            fixed
            bottom
            left
            @click="changeZoom('in')"
            style="margin-left: 142px;"
          >
            <!--@mousedown="continuousZoom('in')"-->
            <!--@touchstart="continuousZoom('in')"-->
            <v-icon>zoom_in</v-icon>
          </v-btn>
          <!-- End Canvas zoom controls -->
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
  import {mapState} from 'vuex';
  import {mapActions} from 'vuex';

  export default {
    data () {
      return {}
    },
    name: 'NoSidebar',
    computed: {
      ...mapState(['canvasZoom'])
      // hScroller() {
      //   return "overflow-x: scroll;";
      // }
    },
    methods: {
      changeZoom(direction) {
        let zoomVal = parseInt(this.canvasZoom);
        if (direction === 'in')
          zoomVal += 5;
        else
          zoomVal -= 5;
        if (zoomVal > this.MAX_CANVAS_ZOOM)
          zoomVal = this.MAX_CANVAS_ZOOM;
        if (zoomVal < this.MIN_CANVAS_ZOOM)
          zoomVal = this.MIN_CANVAS_ZOOM;
        this.setCanvasZoom(zoomVal);
      },
      // continuousZoom(direction) {
      //   setInterval(() => {
      //     this.changeZoom(direction);
      //   }, 300);
      // },
      ...mapActions(['setCanvasZoom'])
    },
    created() {
      this.setCanvasZoom(this.DEFAULT_CANVAS_ZOOM);
    }
  }
</script>



// WEBPACK FOOTER //
// src/appLayouts/NoSidebar.vue